import { ObservableArray, View } from "binder"
import { ProductSearchableSelectorViewModel } from "../productSearch/productSearchableSelector/productSearchableSelector-viewModel";
import { NoSaleLockAmountManipulationViewModel, singleWarehouseProduct } from "./noSaleLockAmountManipulation-viewModel"

export class NoSaleLockAmountManipulationView extends View<NoSaleLockAmountManipulationViewModel>{
    GetViewUniqueId(): string {
        return "V-245E97F5-2454-49D4-BB32-8CCA97EC8287"
    }
    loadHtml(): string {
        let element = require('./noSaleLockAmountManipulation.html').default;
        let style = require('./noSaleLockAmountManipulation.less');
        return element;
    }
    constructor() {
       super();
    }

    
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set searchProduct(v: ProductSearchableSelectorViewModel) { this._searchProduct = v; } public get searchProduct(): ProductSearchableSelectorViewModel { return this._searchProduct;} private _searchProduct: ProductSearchableSelectorViewModel;
    public set productName(v: string) { this._productName = v; } public get productName(): string { return this._productName;} private _productName: string;
    public set productCode(v: string) { this._productCode = v; } public get productCode(): string { return this._productCode;} private _productCode: string;
    public set productCarModel(v: string) { this._productCarModel = v; } public get productCarModel(): string { return this._productCarModel;} private _productCarModel: string;
    public set items(v: ObservableArray<singleWarehouseProduct>) { this._items = v; } public get items(): ObservableArray<singleWarehouseProduct> { return this._items;} private _items: ObservableArray<singleWarehouseProduct>;
    
    refresh(){
        this.dataContext.refresh();
    }
}
